export default {
  Home: 'Home',
  Download: 'Download',
  Help: 'Help',
}
